import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { appNoticeLinks } from '../../../constants/app-notice-card-links';
import { AgencyModel } from '../../../models/agency.model';
import { AppNotice } from '../../../models/app-notice.model';
import { CompanyModel } from '../../../models/company.model';
import { UserModel } from '../../../models/user.model';
import { CurrentContextService } from '../../../services/current-context/current-context.service';

@Component({
  selector: 'core-app-notices',
  templateUrl: './app-notices.component.html',
  styles: [
    `
      .app-notices-container {
        padding: 15px;
        width: 450px;
      }

      .app-notices-badge {
        position: absolute;
        margin-left: -3px;
        margin-top: -9px;
      }

      .alert:last-child {
        margin-bottom: 0;
      }
    `,
  ],
  standalone: false,
})
export class AppNoticesComponent implements OnDestroy, OnInit {
  @Input() public appNotices: AppNotice[] = [];

  public persistentAppNotices = [];
  public agency: AgencyModel;
  public company: CompanyModel;
  public user: UserModel;
  public noticeIndicator = false;
  public appNoticeLinks = appNoticeLinks;

  private agencySubscription: Subscription;
  private userSubscription: Subscription;
  private companySubscription: Subscription;

  constructor(private context: CurrentContextService) {}

  public ngOnInit() {
    this.subscribeToContext();
    this.setNoticeIndicator();
  }

  public ngOnDestroy() {
    if (this.agencySubscription) {
      this.agencySubscription.unsubscribe();
    }
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
    }
    if (this.companySubscription) {
      this.companySubscription.unsubscribe();
    }
  }

  public cardAlertClass(notice: AppNotice) {
    return `card card--alert-${notice.type} card--with-arrow u-no-padding`;
  }

  private get viewedNotices(): string[] {
    return JSON.parse(localStorage.getItem('viewedAppNotices')) || [];
  }

  private setNoticeIndicator() {
    const agencyId = this.agency.id;

    this.noticeIndicator = this.appNotices?.some((notice) => {
      const noticeId = !!notice.id ? notice.id : '';
      return (
        notice &&
        !this.viewedNotices.includes(`${notice.name}${agencyId}${noticeId}`)
      );
    });
  }

  private subscribeToContext() {
    this.agencySubscription = this.context.agency.subscribe(
      (a) => (this.agency = a)
    );
    this.userSubscription = this.context.user.subscribe((u) => (this.user = u));
    this.companySubscription = this.context.company.subscribe(
      (c) => (this.company = c)
    );
  }
}
